import Vue from 'vue';
import get from 'lodash/get';
import { firestoreDocumentsByQuery, executeQueryRaw } from '@/shared/firebase/firestore';
// eslint-disable-next-line import/no-cycle
import { types as authentication } from '@/shared/store/authentication';
// eslint-disable-next-line import/no-cycle
import { types as rootTypes } from './rootTypes';
import {
  findInCollection,
  set,
  getNewDocumentId,
  onSnapshotByQuery,
} from '../firebase/firestoreFunctions';
import { FirestoreOrderBy, FirestoreQuery } from '../firebase/firestoreQuery';

const MODULE_PREFIX = 'sources';
const GETTER_USER_SOURCES = 'userSources';
const GETTER_ALL_SOURCES = 'allSources';
const ACTION_FETCH_USER_SOURCES = 'fetchUserSources';
const ACTION_FETCH_ALL_SOURCES = 'fetchAllSources';
const ACTION_SAVE_USER_SOURCE = 'saveUserSource';
const MUTATION_RECEIVED_USER_SOURCES = 'MUTATION_RECEIVED_USER_SOURCES';
const MUTATION_RECEIVED_ALL_SOURCES = 'MUTATION_RECEIVED_ALL_SOURCES';

const initialState = {
  userSources: [],
  allSources: [],
};

const getters = {
  [GETTER_USER_SOURCES]: state => state.userSources,
  [GETTER_ALL_SOURCES]: state => state.allSources,
};

const mutations = {
  [MUTATION_RECEIVED_USER_SOURCES]: (state, userSources) => {
    Vue.set(state, 'userSources', userSources);
  },
  [MUTATION_RECEIVED_ALL_SOURCES]: (state, allSources) => {
    Vue.set(state, 'allSources', allSources);
  },
};

const receiveUserSources = (commit, snapshot) => {
  let sources = [];

  snapshot.docs.forEach(source => {
    sources.push({
      id: source.id,
      ...source.data(),
    });
  });

  const getTimestamp = (source) => {
    const timestamp = get(source, 'auditInfo.modifiedOn');
    if (timestamp) return timestamp;

    return source.origin.timestamp;
  };
  sources = sources.sort((source1, source2) => getTimestamp(source2) - getTimestamp(source1));
  commit(MUTATION_RECEIVED_USER_SOURCES, sources);
};

const actions = {
  [ACTION_FETCH_USER_SOURCES]: ({ commit, rootGetters }) => {
    const userId = rootGetters[authentication.getters.userId];
    const snapshotListener = onSnapshotByQuery(
      'searchSources',
      receiveUserSources.bind(this, commit),
      [FirestoreQuery.equals('origin.userId', userId)],
      FirestoreOrderBy.descending('origin.timestamp'),
    );
    commit(
      rootTypes.mutations.REGISTER_SNAPSHOT_LISTENER,
      { snapshotListener, id: 'searchSources' },
      { root: true },
    );
  },
  [ACTION_FETCH_ALL_SOURCES]: async ({ commit }) => {
    console.log('Fetch sources');
    const query = firestoreDocumentsByQuery('searchSources', []);
    const snapshots = await executeQueryRaw(query);
    const sources = snapshots.docs.map(s => s.data());

    commit(MUTATION_RECEIVED_ALL_SOURCES, sources);
  },
  [ACTION_SAVE_USER_SOURCE]: async ({ rootGetters }, source) => {
    const userId = rootGetters[authentication.getters.userId];
    const payload = {
      name: source.title,
      ...source,
      origin: {
        type: 'user',
        userId,
        timestamp: Date.now(),
      },
    };

    const snapshots = await findInCollection('searchSources', [
      FirestoreQuery.equals('title', source.title),
      FirestoreQuery.equals('domain', source.domain),
      FirestoreQuery.equals('origin.userId', userId),
    ]);

    let documentId = '';
    if (snapshots.length > 0) {
      const snapshot = snapshots[0];
      documentId = snapshot.id;
      if (snapshot.origin && snapshot.origin.timestamp) {
        payload.origin.timestamp = snapshot.origin.timestamp;
      }
    } else {
      documentId = getNewDocumentId();
    }
    await set('searchSources', documentId, payload);
  },

};

export default {
  namespaced: true,
  state: initialState,
  getters,
  mutations,
  actions,
};

export const types = {
  getters: {
    userSources: `${MODULE_PREFIX}/${GETTER_USER_SOURCES}`,
    allSources: `${MODULE_PREFIX}/${GETTER_ALL_SOURCES}`,
  },
  actions: {
    fetchUserSources: `${MODULE_PREFIX}/${ACTION_FETCH_USER_SOURCES}`,
    fetchAllSources: `${MODULE_PREFIX}/${ACTION_FETCH_ALL_SOURCES}`,
    saveUserSource: `${MODULE_PREFIX}/${ACTION_SAVE_USER_SOURCE}`,
  },
};
